export interface IOrganization {
	charge_model: string;
	city: string;
	commitmentsOU: string;
	country: string;
	created: string;
	is_active: boolean;
	is_managed: boolean;
	is_selected: boolean;
	org_id: number;
	org_name: string;
	reseller_managed: boolean;
	street: string;
	vat_num: unknown;
	zipcode: string;
	api_key: string;
	org_cloud_type?: OrganizationTypes;
	cur_only?: boolean;
	cur_loaded?: boolean;
	is_managed_cm?: boolean;
	is_managed_zd?: boolean;
	is_managed_rds?: boolean;
	is_marketplace_customer?: boolean;
	is_managed_insights?: boolean;
	rds_is_active?: boolean;
}

export enum OrganizationTypes {
	AWS = 'AWS',
	Azure = 'Azure',
}
